import type { CacheConfig, RequestNode, UploadableMap, Variables } from 'relay-runtime';

import * as Sentry from '@sentry/browser';

import { version } from '../../../../package.json';

import { getDomainName, getToken, updateToken } from '../security/auth';

import config from '../config';
import { routeTo } from '../router/utils';

import fetchWithRetries from './fetchWithRetries';

import { getHeaders, getRequestBody, handleData, isMutation } from './helpers';

export const PLATFORM = {
  APP: 'APP',
  WEB: 'WEB',
};

// Define a function that fetches the results of an request (query/mutation/etc)
// and returns its results as a Promise:
const fetchQuery = async (
  request: RequestNode,
  variables: Variables,
  cacheConfig: CacheConfig,
  uploadables: UploadableMap | null,
) => {
  const body = getRequestBody(request, variables, uploadables);

  const authorization = getToken();

  const headers = {
    appversion: version,
    // appbuild: Globals.APP_BUILD,
    appplatform: PLATFORM.WEB,
    ...getHeaders(uploadables),
    authorization,
    domainname: getDomainName(),
    version: 2, // enable 401
  };

  const isMutationOperation = isMutation(request);

  const fetchFn = isMutationOperation ? fetch : fetchWithRetries;

  try {
    const response = await fetchFn(config.GRAPHQL_URL, {
      method: 'POST',
      headers,
      body,
      fetchTimeout: 30000,
      retryDelays: [3000, 5000],
    });

    const data = await handleData(response);

    if (response.status === 401) {
      if (authorization) {
        updateToken(null, false);
        window.location.replace(routeTo('auth.login'));
      }

      throw data.errors;
      // TODO - show snackbar
      // sink.error(data.errors, false);
      // sink.complete();
      // return;
    }

    if (isMutationOperation && data.errors) {
      throw data;
      // sink.error(data);

      // if (complete) {
      //   sink.complete();
      // }

      // throw data;
    }

    // TODO - improve GraphQL Error handler
    // https://github.com/1stdibs/relay-mock-network-layer/pull/6
    // if (response.status === 200 && Array.isArray(data.errors) && data.errors.length > 0) {
    //   sink.error(data.errors, true);
    //   sink.complete();
    //   return;
    // }

    if (!data.data) {
      Sentry.captureException(data.errors);

      throw data.errors;
      // sink.error(data.errors);
      // sink.complete();
      // return;
    }

    // sink.next(data);
    // sink.next({
    //   operation: request.operation,
    //   variables,
    //   response: data,
    // });

    // if (complete) {
    //   sink.complete();
    // }

    return data;
    // return {
    //   operation: request.operation,
    //   variables,
    //   response: data,
    // };
  } catch (err) {
    // eslint-disable-next-line
    console.log('err:', err);

    Sentry.captureException(err);

    // TODO - handle no successfull response after
    const timeoutRegexp = new RegExp(/Still no successful response after/);
    const serverUnavailableRegexp = new RegExp(/Failed to fetch/);

    if (timeoutRegexp.test(err.message) || serverUnavailableRegexp.test(err.message)) {
      throw new Error('Serviço indisponível. Tente novamente mais tarde.');
      // sink.error(new Error('Serviço indisponível. Tente novamente mais tarde.'));

      // throw new Error('Serviço indisponível. Tente novamente mais tarde.');
    }

    throw err;
    // sink.error(err);
    // throw err;
  }
};

export default fetchQuery;
